import { Box, makeStyles } from "@material-ui/core";
import { FakeReferenceTextField } from "components/fields/FakeReferenceTextField";
import { SplitOrdersType } from "entities/SplitOrdersType";
import React from "react";
import {
	ArrayField,
	Datagrid,
	FunctionField,
	ReferenceField,
	TextField,
	useTranslate,
} from "react-admin";

import { SelectEnumField } from "../../../components/fields/SelectEnumField";
import { DeleteButton } from "../../../components/toolbars/DeleteButton";
import { optionalMapperKeys } from "../../../entities/MapperData";
import { MapperTypeCompanyLevel } from "../../../entities/MapperType";
import { AddMapper } from "./AddMapper";
import { UpdateMapper } from "./UpdateMapper";

const useStyles = makeStyles((theme) => ({
	customHeaderRequired: {
		backgroundColor: "#C5E1B2",
	},
	customHeaderOptional: {
		backgroundColor: "#F7F1C6",
	},
	optionalLable: {
		fontStyle: "italic",
	},
}));

const mapperDataRowStyle = (type) => (record, index) => {
	return {
		backgroundColor:
			optionalMapperKeys[type.toString()].includes(record["key"]) &&
			type !== MapperTypeCompanyLevel.none
				? "#F7F1C6"
				: "#F0F0F0",
	};
};

export const CustomerCompaniesMappersList = (props) => {
	const classes = useStyles();
	const translate = useTranslate();

	return (
		<>
			<Box display="flex" justifyContent="right" padding={1}>
				<AddMapper company_id={props.id} defaultValue={props.defaultValue} />
			</Box>
			<Datagrid>
				<TextField source="id" label="resources.customer-companies-mappers.fields.id" />
				{/* <FakeReferenceTextField
					label="resources.customer-companies-mappers.fields.company_id"
					source="company_id"
					replaceSource="company_name"
				/> */}
				<TextField source="name" label="resources.customer-companies-mappers.fields.name" />
				{/* <TextField source="type" label="resources.customer-companies-mapper.fields.type"/> */}
				<SelectEnumField
					source="type"
					label="resources.customer-companies-mappers.fields.type"
					enumName="type"
					enumObj={MapperTypeCompanyLevel}
				/>
				<FunctionField
					source=""
					label={translate("resources.customer-companies-mappers.fields.settings")}
					render={(mapperRecord) => (
						<ArrayField source="settings" sortable={false}>
							<Datagrid
								bulkActionButtons={false}
								classes={{ headerCell: classes.customHeaderRequired }}
								rowStyle={mapperDataRowStyle(mapperRecord["type"])}
							>
								<FunctionField
									source=""
									label="resources.mappers.fields.settings_field.key"
									render={(dataRecord) =>
										mapperRecord["type"] !== MapperTypeCompanyLevel.none ? (
											<div>
												{translate(`resources.mappers.fields.settings_field.${dataRecord.key}`)}
											</div>
										) : (
											<div>{dataRecord.key}</div>
										)
									}
								/>
								<FunctionField
									source=""
									label="resources.mappers.fields.settings_field.value"
									render={(dataRecord) =>
										dataRecord.key === "order_import_split_orders_type" ? (
											<SelectEnumField
												source="value"
												label="resources.customer-companies-mappers.fields.data_field.value"
												enumName="split-orders-type"
												enumObj={SplitOrdersType}
											/>
										) : (
											<TextField
												source="value"
												label="resources.customer-companies-mappers.fields.data_field.value"
											/>
										)
									}
								/>
							</Datagrid>
						</ArrayField>
					)}
				/>
				<FunctionField
					source=""
					label={translate("resources.customer-companies-mappers.fields.data")}
					render={(mapperRecord) => (
						<ArrayField source="data" sortable={false}>
							<Datagrid
								bulkActionButtons={false}
								classes={{ headerCell: classes.customHeaderRequired }}
								rowStyle={mapperDataRowStyle(mapperRecord["type"])}
							>
								<FunctionField
									source=""
									label="resources.customer-companies-mappers.fields.data_field.key"
									render={(dataRecord) =>
										mapperRecord["type"] !== MapperTypeCompanyLevel.none ? (
											<div>
												{translate(`resources.mappers.fields.data_field.${dataRecord.key}`) +
													` (${dataRecord.key})`}
											</div>
										) : (
											<div>{dataRecord.key}</div>
										)
									}
								/>
								<TextField
									source="value"
									label="resources.customer-companies-mappers.fields.data_field.value"
								/>
							</Datagrid>
						</ArrayField>
					)}
				/>
				<FunctionField source="" render={(record) => <UpdateMapper mappers={record} />} />
				<DeleteButton
					resource={props.resource}
					notifyMessage="osfc.dialogs.confirm_delete_mappers.success"
					title="osfc.dialogs.confirm_delete_mappers.confirm.title"
					content="osfc.dialogs.confirm_delete_mappers.confirm.content"
				/>
			</Datagrid>
		</>
	);
};
